export const fieldInfoSettingsViewValidations = {
  methods: {
    generateDynamicFieldRules() {
      this.editFieldsInfoSettingsFormRules = {
        fieldsInfoSettings: this.form.fieldsInfoSettings.map((item, index) => {
          const type = item.info_type || `item ${index + 1}`;

          return {
            [`fieldsInfoSettings.${index}.range1s`]: [
              {
                required: true,
                // message: `*Range start for ${type} is required`,
                message: `This value is required`,
                trigger: 'blur',
              },
            ],
            [`fieldsInfoSettings.${index}.range1e`]: [
              {
                required: true,
                // message: `Range end for ${type} is required`,
                message: `This value is required`,
                trigger: 'blur',
              },
            ],
            [`fieldsInfoSettings.${index}.range2s`]: [
              {
                required: true,
                // message: `*Warning start for ${type} is required`,
                message: `This value is required`,
                trigger: 'blur',
              },
            ],
            [`fieldsInfoSettings.${index}.range2e`]: [
              {
                required: true,
                // message: `*Warning end for ${type} is required`,
                message: `This value is required`,
                trigger: 'blur',
              },
            ],
            [`fieldsInfoSettings.${index}.range3s`]: [
              {
                required: true,
                // message: `Critical start for ${type} is required`,
                message: `This value is required`,
                trigger: 'blur',
              },
            ],
            [`fieldsInfoSettings.${index}.range3e`]: [
              {
                required: true,
                // message: `Critical end for ${type} is required`,
                message: `This value is required`,
                trigger: 'blur',
              },
            ],
          };
        }).reduce((acc, cur) => Object.assign(acc, cur), {}),
      };
    },
  },
};